import { Button } from '@usitsdasdesign/dds-react';
import Heading from 'atoms/Heading';
import Icon from 'atoms/Icon';
import useClickOutside from 'components/useClickOutSide';
import { useRef } from 'react';

function PopOver({
    targetLabel = 'Open',
    targetKind = 'primaryLoud',
    width = 'w-[100vw] md:w-[400px]',
    position = 'top-right',
    footerButtons = [],
    children,
    label = 'Send a note',
    className = '',
    showPopOver = false,
    setShowPopOver = () => { },
    targetClass,
    customTarget,
    targetSize = 'l',
    variant = 'default',
    showHeader = true,
    popOverClass,
    spacing = 'px-5'
}) {

    const ref = useRef();

    useClickOutside(ref, () => setShowPopOver(false));

    const positionStyle = {
        'top-right': 'right-0 mt-2'
    };

    const variantStyle = {
        'default': '',
        'responsive': 'top-0 h-[calc(100vh-3rem)] top-10 md:h-auto md:top-auto'
    }

    return (
        <div className={`relative ${className}`}>
            {
                customTarget ? <div onClick={() => setShowPopOver(true)}>{customTarget}</div> : (
                    <Button
                        label={targetLabel}
                        kind={targetKind}
                        size={targetSize}
                        onClick={() => setShowPopOver(true)}
                        className={`w-full ${targetClass}`}
                    />
                )
            }
            {
                showPopOver && (
                    <div ref={ref} className={`flex flex-col fixed md:absolute shadow-xxl z-[333] bg-white ${width} ${positionStyle[position]} ${variantStyle[variant]} ${popOverClass} ${spacing}`}>
                        {
                            showHeader && (
                                <div className='py-3 flex items-center justify-between'>
                                    <Heading type='h5'>{label}</Heading>
                                    <Icon icon="close__l__stroke" className='cursor-pointer' onClick={() => setShowPopOver(false)} size='w-4 h-4' />
                                </div>
                            )
                        }
                        <div className='py-2'>
                            {children}
                        </div>
                        {
                            footerButtons.length > 0 && (
                                <div className='flex items-center gap-2 justify-end py-4'>
                                    {
                                        footerButtons.map((button, i) => {
                                            return (
                                                <Button
                                                    {...button}
                                                />
                                            )
                                        })
                                    }
                                </div>
                            )
                        }
                    </div>
                )
            }
        </div>
    )
}

export default PopOver